import { useState } from 'react';
import i18n from 'i18next';

import { ReactComponent as ZoomIcon } from '../../../assets/icons/zoom-input.svg';
import PortSearchModal from '../../screens/common/PortSearchModal/PortSearchModal';
import IconButton from '../Buttons/IconButton';
import SvgConverter from '../Common/SvgConverter';
import FormInput from '../Inputs/FormInput';

const HalPortNameSelector = ({
  placeholder = i18n.t('translation:default.fields.portName.select'),
  label = i18n.t('translation:default.fields.portName.label'),
  rules,
  name,
  editMode,
  portRecKey = '',
  portType,
  countryCode = '',
  cityCode = '',
  stateCode = '',
  zipCode = '',
  portCode = '',
  portName = '',
  onChange = () => {},
  margin = 'mb-0',
  handlePortDetails,
  labelForTestId = '',
  readOnly = false,
  dataTestId = '',
  isRequired = false,
}) => {
  const [modal, setModal] = useState(false);

  const handleSelect = (data) => {
    handlePortDetails(data);
    setModal(false);
  };

  const handleShowModal = () => {
    editMode && setModal(true);
  };

  const handleInputClick = () => {
    readOnly && handleShowModal();
  };

  return (
    <>
      <FormInput
        onClick={handleInputClick}
        onChange={onChange}
        readOnly={readOnly}
        placeholder={placeholder}
        label={label}
        margin={margin}
        rules={rules}
        name={name}
        editMode={editMode}
        addonAfter={
          <IconButton onClick={handleShowModal}>
            <SvgConverter Icon={ZoomIcon} color="muted" />
          </IconButton>
        }
        data-testid={dataTestId}
        isRequired={isRequired}
      />
      <PortSearchModal
        open={modal}
        handleSelect={handleSelect}
        handleClose={() => setModal(false)}
        portRecKey={portRecKey}
        portType={portType}
        countryCode={countryCode}
        cityCode={cityCode}
        stateCode={stateCode}
        zipCode={zipCode}
        portCode={portCode}
        portName={portName}
        labelForTestId={`${labelForTestId}-modal`}
      />
    </>
  );
};

export default HalPortNameSelector;
